import React from "react";
import {Box, BoxProps} from "@amzn/awsui-components-react";

const BoxPaddedBottom: React.FC<BoxProps> = (props) => {
    return (
        <Box padding={{bottom: "xs"}} {...props}>{props.children}</Box>
    )
}

export default BoxPaddedBottom;